module.exports = __webpack_public_path__ + "img/role01.4352825e.png";